import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import moment from 'moment-tz';
import styled from 'styled-components';

const StyledContainerLi = styled.li`
  @media (min-width: 576px) {
    border-bottom: 1px solid ${colors.borderGray};
  }

  .day-container {
    @media (max-width: 767px) {
      border-bottom: 1px solid ${colors.borderGray};
    }

    @media (max-width: 575px) {
      background: ${colors.lightBg};
    }
  }

  .weekday,
  .monthday {
    letter-spacing: -0.25pt;
    text-transform: uppercase;
    font-weight: bold;
  }

  .weekday {
    font-size: 0.7rem;
  }

  .monthday {
    font-size: 0.8rem;
  }

  @media (max-width: 575px) {
    .task-item {
      border-bottom: 1px solid ${colors.borderGray};
    }
  }
`;

type GroupByDayComponentProps = {
  day: string;
  userTimezone: string;
  children: React.ReactNode;
};
export const GroupByDayComponent = ({
  day,
  userTimezone,
  children,
}: GroupByDayComponentProps) => {
  const now = moment().tz(userTimezone);
  const date = moment(day, 'YYMMDD');
  const sameYear = date.year() === now.year();
  return (
    <StyledContainerLi className="row" key={day}>
      <div className="col-xl-1 col-12 col-md-2 py-2 day-container">
        <div className="d-none d-md-block" title={date.format('ll')}>
          <div className="weekday">{date.format('ddd')}</div>
          <div className="monthday">
            {date.format(`D MMM${sameYear ? '' : ' Y'}`)}
          </div>
        </div>
        <div className="d-md-none">
          <div className="monthday">{date.format('LL')}</div>
        </div>
      </div>
      <div className="col-xl-11 col-md-10 col-12">{children}</div>
    </StyledContainerLi>
  );
};

const StyledMomentLineDIV = styled.div`
  height: 2px;
  position: relative;
  margin-left: -8px;
  margin-right: -15px;

  &,
  .circle {
    background: ${colors.lightLinkBlue};
  }

  .circle {
    position: absolute;
    height: 8px;
    width: 8px;
    top: -3px;
    left: -7px;
    border-radius: 100%;
  }
`;

const StyledCompactTaskItem = styled.div.attrs<{className?: string}>({
  className: 'task-item row py-2',
})`
  . &.past {
    .due,
    .past-opacity,
    .title-container {
      opacity: 0.6;
    }
  }

  > div {
    display: flex;
    align-items: center;
  }
`;

type StyledTaskItemComponentProps = {
  showNowLine: boolean | undefined;
  isPast: boolean;
  PresenceNode: React.ReactNode;
  TimeNode: React.ReactNode;
  AssignedNode: React.ReactNode;
  StatsNode?: React.ReactNode;
  ItemNameNode: React.ReactNode;
  ActionsNode: React.ReactNode;
};

export const StyledTaskItemComponent = ({
  showNowLine,
  isPast,
  PresenceNode,
  TimeNode,
  AssignedNode,
  StatsNode,
  ItemNameNode,
  ActionsNode,
}: StyledTaskItemComponentProps) => {
  return (
    <div className="row">
      <div className="col">
        {showNowLine ? (
          <StyledMomentLineDIV>
            <div className="circle" />
          </StyledMomentLineDIV>
        ) : null}

        {PresenceNode}

        <StyledCompactTaskItem className={isPast ? 'past' : ''}>
          <div className="pr-3 pr-sm-0 pl-sm-3 pl-0 col-6 col-sm-3 col-xl-2 due text-nowrap text-truncate order-6 order-sm-1">
            {TimeNode}
          </div>
          <div className="col-2 col-sm-1 pr-3 pl-0 past-opacity order-3 order-sm-2 d-flex align-items-start align-items-sm-center">
            {AssignedNode}
          </div>
          <div className="col-5 col-sm-2 past-opacity order-5 order-sm-4 offset-1 offset-sm-0">
            {StatsNode}
          </div>

          <div className="d-sm-none w-100 order-4" />

          <div className="col pl-sm-0 title-container text-truncate text-nowrap order-2 order-sm-3">
            {ItemNameNode}
          </div>
          <div className="col-1 col-sm-auto pl-0 order-1 order-sm-5 d-flex align-items-start align-items-sm-center flex-row flex-column-reverse flex-sm-row">
            {ActionsNode}
          </div>
        </StyledCompactTaskItem>
      </div>
    </div>
  );
};
